import { render, staticRenderFns } from "./Monitor2SettingsPopup.vue?vue&type=template&id=9f10b8c6"
import script from "./Monitor2SettingsPopup.vue?vue&type=script&lang=js"
export * from "./Monitor2SettingsPopup.vue?vue&type=script&lang=js"
import style0 from "./Monitor2SettingsPopup.vue?vue&type=style&index=0&id=9f10b8c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports